import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=179839da&scoped=true&"
import script from "./BankAccountList.vue?vue&type=script&lang=ts&"
export * from "./BankAccountList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179839da",
  null
  
)

export default component.exports